import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import AuthLayout from "@/components/AuthLayout";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Spinner } from "@/components/States";

export function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const submit = async (e) => {
    e.preventDefault(); setBusy(true); setError("");
    try { await api.post("/auth/forgot-password", { email }); setSent(true); }
    catch (err) { setError(errMsg(err)); } finally { setBusy(false); }
  };
  return (
    <AuthLayout eyebrow="Account help" title="Reset your password">
      {sent ? (
        <div className="space-y-4" data-testid="forgot-sent-message">
          <p className="text-sm text-muted-foreground">If that email has an account, a reset link has been created. Your studio admin can also generate one for you from Team &amp; Invites.</p>
          <Link to="/login" className="text-sm underline" data-testid="back-to-login-link">Back to sign in</Link>
        </div>
      ) : (
        <form onSubmit={submit} className="space-y-5">
          <div className="space-y-2"><Label htmlFor="fp-email">Email</Label>
            <Input id="fp-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} data-testid="forgot-email-input" /></div>
          {error && <p role="alert" className="text-sm text-destructive">{error}</p>}
          <Button type="submit" className="w-full rounded-full" disabled={busy} data-testid="forgot-submit-button">{busy && <Spinner />} Send reset link</Button>
          <Link to="/login" className="block text-sm text-muted-foreground underline-offset-4 hover:underline">Back to sign in</Link>
        </form>
      )}
    </AuthLayout>
  );
}

export function ResetPassword() {
  const [params] = useSearchParams();
  const nav = useNavigate();
  const [pw, setPw] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const submit = async (e) => {
    e.preventDefault(); setBusy(true); setError("");
    try {
      await api.post("/auth/reset-password", { token: params.get("token") || "", password: pw });
      toast.success("Password updated. Please sign in.");
      nav("/login");
    } catch (err) { setError(errMsg(err)); } finally { setBusy(false); }
  };
  return (
    <AuthLayout eyebrow="Account help" title="Choose a new password">
      <form onSubmit={submit} className="space-y-5">
        <div className="space-y-2"><Label htmlFor="rp">New password (8+ characters)</Label>
          <Input id="rp" type="password" minLength={8} required value={pw} onChange={(e) => setPw(e.target.value)} data-testid="reset-password-input" /></div>
        {error && <p role="alert" className="text-sm text-destructive" data-testid="reset-error">{error}</p>}
        <Button type="submit" className="w-full rounded-full" disabled={busy} data-testid="reset-submit-button">{busy && <Spinner />} Update password</Button>
      </form>
    </AuthLayout>
  );
}
